import type { FoldingCardProp } from "@components/FoldingCardProp.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getMobileAppsPros(tenant: Tenant): FoldingCardProp[] {
	return [
		{
			title: "Rychlejší vývoj a nižší náklady",
			desc: "Při vvytváření hybridních mobilních aplikací používáme stejný kód pro platformy Android i iOS, tím pádem vývoj nemusíme provádět dvakrát. Díky tomu aplikaci vytvoříme rychleji a ušetříme vám až polovinu nákladů.",
		},
		{
			title: "Výborný poměr cena/výkon",
			desc: "Hybridně vyvinuté mobilní aplikace se pyšní uživatelskou přívětivostí, dostatečným výkonem a jsou výborné v poměru k pořizovací ceně. Splňují nároky většiny našich zákazníků.",
		},
		{
			title: "Snadná údržba a aktualizace",
			desc: "Hybridní mobilní aplikace se snadno spravují i aktualizují (jedna aktualizace se projeví na obou operačních systémech), takže vám nezpůsobí zbytečné starosti během jejich provozování.",
		},
		{
			title: "Stejné uživatelské rozhraní pro Android i iOS",
			desc: "Díky hybridnímu vývoji bude vaše aplikace vypadat a fungovat stejně na všech zařízeních, bez ohledu na to, jestli ji otevřete na Androidu nebo iOS. Všude má nejen stejný kód, ale i jednotné uživatelské rozhraní.",
		},
	];
}
